import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';


function signOut() {
  Auth.signOut().then(() => {
    localStorage.setItem("loggedin", "0");
    setTimeout(
      function(){
      window.location.href = "/"; }, 100
    );
    //window.location.href = "/";
    //this.setState({authState: 'signIn'});

  }).catch(e => {
    console.log(e);
  });
}

const Hello = () => {

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState('');

  const [user, setUser] = useState(false);

  useEffect(() => {
    try {
      setError(null);
      setLoading(true);

      Auth.currentAuthenticatedUser({
        bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      }).then(user => {
        setUsername(user.username);
        setUser(user);
        localStorage.setItem("user", user.username);
        console.log(`Load additional settings for user: ${user.username}`);
        // TBD
      }).catch(err => {
        setError(err);
        setUser(user);
      });
    }
    catch (e) {
      setError(e);
      setUser(user);
    }
    finally {
      setLoading(false);
    }
  }, []);


  return (
    <header className="navbar">
      <h1 className="site-title"><a href="/">Polyg.io</a></h1>
      <div className="user-info">
        {error ? `Oops... ${error}` : null}
        {loading ? "Loading..." : `Hello ${user.username}`}
        <button onClick={signOut} className="button small-text">Sign Out</button>
      </div>
    </header>
  )

};

export default Hello;
